import styled from '@emotion/styled';
import { Typography } from '@kc-console/common-ui';

import MenuItem from './MenuItem';

import type { MegaMenuCategory } from '@kc-console/context';

interface Props {
  category: MegaMenuCategory;
  type: 'all' | 'category';
}

const CategorySection = ({ category, type }: Props) => {
  return (
    <>
      <CategoryTitle variant={'heading/semibold/md'}>{category.name}</CategoryTitle>
      <MenuItemContainer>
        {category.services.map(service => (
          <MenuItem key={service.name} service={service} type={type} />
        ))}
      </MenuItemContainer>
    </>
  );
};

export const CategoryTitle = styled(Typography)`
  padding: 6px 8px;
  line-height: 20px;
`;

export const MenuItemContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export default CategorySection;
